import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Col, Input, Label} from 'reactstrap'
import {Query} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {AvForm, AvField} from 'availity-reactstrap-validation'

import Loading from '../Loading'

import query from '../../../queries/server/office_users'
import {checkPermission, ANNUAL_LEAVE_CAN_REQUEST_LEAVE_FOR_OTHER_USERS} from "../../../lib/permissions";

export default class AnnualLeaveInput extends Component{
  
  render(){

    const {
      title, 
      isOpen, 
      toggle, 
      onSave, 
      onChange, 
      onUsersAdded,
      onUsersRemoved,
      loading, 
      saving, 
      start_date, 
      start_of_day, 
      end_date, 
      end_of_day,
      selectedUsers,
      whoFor,
      errors,
    } = this.props

    if(loading){
      return (
        <Modal isOpen={isOpen} size="lg">
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
              <Loading/>
          </ModalBody>
      </Modal>
      )
    }

    return(
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <AvForm onValidSubmit={() => onSave(this.props)}>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            <FormGroup row style={{marginBottom: '0px'}}>
              <Col sm="7" style={{paddingRight: '5px'}}>
                <AvField
                  required
                  bsSize="sm"
                  type="date"
                  errorMessage="Required"
                  name="start_date"
                  label="Start Date *"
                  value={start_date}
                  onChange={(evt) => onChange({key: 'start_date', value: evt.target.value})}
                />
              </Col>
              <Col sm="5" style={{paddingLeft: '5px'}}>
                <AvField
                  required
                  bsSize="sm"
                  type="select"
                  errorMessage="Required"
                  name="start_of_day"
                  label="&nbsp;"
                  value={start_of_day}
                  onChange={(evt) => onChange({key: 'start_of_day', value: evt.target.value})}
                >
                  <option value={1}>Start of Day</option>
                  <option value={0}>Afternoon</option>
                </AvField>
              </Col>
            </FormGroup>

            <FormGroup row style={{marginBottom: '0px'}}>
              <Col sm="7" style={{paddingRight: '5px'}}>
                <AvField
                  required
                  bsSize="sm"
                  type="date"
                  errorMessage="Required"
                  name="end_date"
                  label="End Date *"
                  value={end_date}
                  onChange={(evt) => onChange({key: 'end_date', value: evt.target.value})}
                />
              </Col>
              <Col sm="5" style={{paddingLeft: '5px'}}>
                <AvField
                  required
                  bsSize="sm"
                  type="select"
                  errorMessage="Required"
                  name="end_of_day"
                  label="&nbsp;"
                  value={end_of_day}
                  onChange={(evt) => onChange({key: 'end_of_day', value: evt.target.value})}
                >
                  <option value={1}>End of Day</option>
                  <option value={0}>Afternoon</option>
                </AvField>
              </Col>
            </FormGroup>

            {checkPermission(ANNUAL_LEAVE_CAN_REQUEST_LEAVE_FOR_OTHER_USERS) && (<div>
              <AvField
                required
                bsSize="sm"
                type="select"
                errorMessage="Required"
                name="who_for"
                label="Who is the leave for?"
                value={whoFor}
                onChange={(evt) => onChange({key: 'whoFor', value: evt.target.value})}
              >
                <option value={1}>Myself</option>
                <option value={0}>Other Staff</option>
              </AvField>

              {whoFor == 0 && <Query query={query}>
                {({data, loading}) => {
                  if(loading) return <Loading />

                  return data.offices.map((office) => {
                    return (
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-row pb-2 pt-2 border-bottom align-items-baseline">
                          {office.description}
                          <small className="pl-1">
                            <a href="#" onClick={() => {
                              onUsersAdded(office.active_users.map(({user_id}) => user_id))
                            }}>Select All</a>
                          </small>
                        </div>
                        {office.active_users.map((user) => (
                          <div className="d-flex flex-column pl-4 pr-2">
                            <Label>
                              <Input 
                                type="checkbox"
                                checked={selectedUsers.includes(user.user_id)}
                                onChange={(evt) => {
                                  if (selectedUsers.includes(user.user_id)) {
                                    onUsersRemoved([user.user_id])
                                  }
                                  else {
                                    onUsersAdded([user.user_id])
                                  }
                                }}
                              />
                              {user.full_name}
                            </Label>
                            {errors[user.user_id] && <small className="text-danger">{errors[user.user_id]}</small>}
                          </div>
                        ))}
                      </div>
                      
                    )
                  })
                }}
              </Query>}
            </div>)}

          </ModalBody>
          <ModalFooter>
            <Button size="sm" color="success" disabled={saving}>
              <FontAwesomeIcon
                  color="#fff"
                  icon={saving ? 'spinner' : 'save'}
                  spin={saving}
              />{' '}
              {saving ? 'Saving...' : 'Save'}
            </Button>
          </ModalFooter>
        </AvForm>
      </Modal>
    )
  }
}